import PropTypes from 'prop-types';
import React from 'react';

export default class RouterLayout extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired, // this is passed from the Rails view
  };

  /**
   * @param props - Comes from your rails view.
   */
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <div className="web-pc-app-container">
        {this.props.children && React.cloneElement(this.props.children, {})}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/bundles/LoginPcApp/components/RouterLayout.jsx